import { useContext } from "react";
import { ThemeContext } from "../../contexts/theme";

/**
 * Hook for accessing the current theme from context
 * Returns the theme object from ThemeContext
 *
 * @returns {Object} The current theme object
 */
export const useTheme = () => {
  const { theme } = useContext(ThemeContext);

  return theme;
};
